import { createBrowserHistory } from "history";
import { pathPrefix } from 'DVWebNodeUtils'

const history = global.__NATIVEAPP__ ? createBrowserHistory({
  basename: pathPrefix(document.location.pathname)
}) : null;

export default history

export const HISTORY_STORAGE = 'spaHistoryCount'
export class SPAHistory {
  count: number = typeof window !== 'undefined' ? this.getInitialCount() : 0
  
  push() {
    this.count = this.count + 1
    localStorage.setItem(HISTORY_STORAGE, String(this.count))
  }
  
  pop() {
    this.count = this.count - 1
    localStorage.setItem(HISTORY_STORAGE, String(this.count))
  }
  
  showBack() {
    let showBackButton = false
    if(history.length > 1 && this.count > 0) {
      showBackButton = true
    }
  return showBackButton
  }
  
  getInitialCount() {
    let count = 0
    if(typeof window !== 'undefined' && !/ref=(av_auth_return_redir|dv_web_auth_no_re_sig)/.test(window.location.href)){
      const storageCount = localStorage.getItem(HISTORY_STORAGE)
      count = Number(storageCount) || 0
    }
    localStorage.setItem(HISTORY_STORAGE, String(count))
    
    return count
  }
}